"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readChatTail = readChatTail;
const dist_1 = require("../../core/dist");
/**
 * Returns only the chat turns since the AI last replied (content after the last AI
 * block), so a first-touch read costs the tail instead of the whole chat. Prefers the
 * stored `last_ai_block` cursor; falls back to computing it from the body for chats
 * written before the cursor existed.
 */
async function readChatTail(input, deps) {
    const { id, filePath } = await deps.resolveDocId(deps.loomRoot, input.id);
    const doc = await deps.loadDoc(filePath);
    if (doc.type !== 'chat') {
        throw new Error(`'${id}' is not a chat document (type: ${doc.type}). loom_read_chat_tail only reads chats.`);
    }
    const body = doc.content ?? '';
    const aiHeader = deps.aiName(deps.loomRoot);
    const idx = typeof doc.last_ai_block === 'number' ? doc.last_ai_block : (0, dist_1.lastAiBlockIndex)(body, aiHeader);
    const tail = (0, dist_1.tailAfterBlock)(body, idx);
    return { id, tail, hasNew: tail.length > 0, lastAiBlock: idx };
}
